/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoodsInfoOrderInfoForInboundPictureVo
 */
export interface GoodsInfoOrderInfoForInboundPictureVo {
    /**
     * 商品id
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo
     */
    goodsId?: string;
    /**
     * 订单号
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo
     */
    orderCode?: string;
    /**
     * 接收人
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo
     */
    receiver?: string;
    /**
     * 商品数量
     * @type {number}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo
     */
    goodsCode?: number;
    /**
     * 商品图片
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo
     */
    goodsImg?: string;
    /**
     * 颜色颜色
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo
     */
    size?: string;
    /**
     * 数量
     * @type {number}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo
     */
    quantity?: number;
    /**
     * 商品状态
     * @type {string}
     * @memberof GoodsInfoOrderInfoForInboundPictureVo
     */
    goodsStatusName?: string;
}

/**
 * Check if a given object implements the GoodsInfoOrderInfoForInboundPictureVo interface.
 */
export function instanceOfGoodsInfoOrderInfoForInboundPictureVo(value: object): value is GoodsInfoOrderInfoForInboundPictureVo {
    return true;
}

export function GoodsInfoOrderInfoForInboundPictureVoFromJSON(json: any): GoodsInfoOrderInfoForInboundPictureVo {
    return GoodsInfoOrderInfoForInboundPictureVoFromJSONTyped(json, false);
}

export function GoodsInfoOrderInfoForInboundPictureVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsInfoOrderInfoForInboundPictureVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'receiver': json['receiver'] == null ? undefined : json['receiver'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'goodsImg': json['goodsImg'] == null ? undefined : json['goodsImg'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'goodsStatusName': json['goodsStatusName'] == null ? undefined : json['goodsStatusName'],
    };
}

export function GoodsInfoOrderInfoForInboundPictureVoToJSON(json: any): GoodsInfoOrderInfoForInboundPictureVo {
    return GoodsInfoOrderInfoForInboundPictureVoToJSONTyped(json, false);
}

export function GoodsInfoOrderInfoForInboundPictureVoToJSONTyped(value?: GoodsInfoOrderInfoForInboundPictureVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'orderCode': value['orderCode'],
        'receiver': value['receiver'],
        'goodsCode': value['goodsCode'],
        'goodsImg': value['goodsImg'],
        'color': value['color'],
        'size': value['size'],
        'quantity': value['quantity'],
        'goodsStatusName': value['goodsStatusName'],
    };
}

